
// Require the IntersectionObserver polyfill before requiring any other modules.
import 'intersection-observer';

/**
 * Use this image tag, loading="lazy" is for new chromium feature that support officially lazy load images
 *
 * <img class="lazy" loading="lazy"
 *    src="placeholder-image.jpg"
 *    data-src="image-to-lazy-load-1x.jpg"
 *    data-srcset="image-to-lazy-load-2x.jpg 2x, image-to-lazy-load-1x.jpg 1x"
 *    alt="I'm an image!">
 *
 * @see https://developers.google.com/web/fundamentals/performance/lazy-loading-guidance/images-and-video
 */
document.addEventListener("DOMContentLoaded", function() {

  if ('loading' in HTMLImageElement.prototype) {

    // console.log('detected browser supporting new img loading="lazy" attribute feature');

    const images = document.querySelectorAll('img[loading="lazy"]');
    images.forEach(img => {
      img.src = img.dataset.src;
      img.classList.remove("lazy");
    });

  } else {

    var lazyImages = [].slice.call(document.querySelectorAll("img.lazy"));

    if ("IntersectionObserver" in window) {
      let lazyImageObserver = new IntersectionObserver(function(entries, observer) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            let lazyImage = entry.target;
            lazyImage.src = lazyImage.dataset.src;
            // lazyImage.srcset = lazyImage.dataset.srcset;
            lazyImage.classList.remove("lazy");
            lazyImageObserver.unobserve(lazyImage);
          }
        });
      });

      lazyImages.forEach(function(lazyImage) {
        lazyImageObserver.observe(lazyImage);
      });

    } else {
      // Possibly fall back to a more compatible method here
      // IntersectionObserver polyfill is loaded to handle this situation
    }
  }
});
